import { render } from "./coaches-map.vue?vue&type=template&id=1804d252"
import script from "./coaches-map.vue?vue&type=script&lang=js"
export * from "./coaches-map.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__